import {
  joinClasses,
  BESPOKE_SECTION_LABEL_CLASS,
  BESPOKE_TITLE_LABEL_BLOCK_CLASS,
} from '../../primitives/fieldClassSlots';
import { layoutInlineStyle } from '../layoutInlineStyle';
import type { SectionLabelNode } from '../types';

export function SectionLabel({ node }: { node: SectionLabelNode }) {
  const SECTION_LABEL_VARIANT_CLASS: Record<
    'section' | 'title' | 'hint',
    string
  > = {
    section: BESPOKE_SECTION_LABEL_CLASS,
    title: BESPOKE_TITLE_LABEL_BLOCK_CLASS,
    hint: 'text-xs font-normal leading-snug text-muted-foreground mb-1',
  };

  return (
    <p
      className={joinClasses(
        SECTION_LABEL_VARIANT_CLASS[node.variant ?? 'section'],
        node.className
      )}
      style={layoutInlineStyle(node.style)}
    >
      {node.text}
    </p>
  );
}
